import { useGoogleLogin } from '@react-oauth/google'
import axios from 'axios'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import GoogleIcon from '../assets/icons/GoogleIcon'

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/v1` : 'http://localhost:8001'

const Login = () => {
    const navigate = useNavigate()

    const handleAuthenticate = async (authDetails) => {
        try {
            const response = await axios.post(`${API_URL}/signup`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    Authorization: `Bearer ${authDetails?.access_token}`
                }
            })

            if (response.status === 200 || response.status === 201) {
                localStorage.setItem("token", response.data.jwt)
                navigate("/tasks")
            } else {
                throw new Error("Authentication failed")
            }
        } catch (error) {
            console.error("Authentication error:", error)
            alert("Something went wrong during authentication")
        }
    }

    const handleLogin = useGoogleLogin({
        onSuccess: handleAuthenticate
    })

    return (
        <div className="font-sans min-h-screen flex flex-col items-center justify-center">
            <div className="grid md:grid-cols-2 items-center gap-4 max-md:gap-8 max-w-6xl w-full p-4 m-4 rounded-md">
                <div className="md:h-full bg-[#000842] rounded-xl lg:p-12 p-8">
                    <img src="https://readymadeui.com/signin-image.webp" className="w-full h-full object-contain" alt="login" />
                </div>
                <div className="md:max-w-md w-full px-4 py-4">
                    <h3 className="text-gray-800 text-3xl font-extrabold mb-4">Sign in</h3>
                    <button
                        onClick={handleLogin}
                        type="button"
                        className="w-full flex items-center gap-2 justify-center shadow-xl py-2.5 px-4 text-sm tracking-wide rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
                    >
                        <GoogleIcon /> <span>Sign in with Google</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Login